/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const returnColor = (disable: boolean, color: any, theme: any) => {
    if (disable) {
        return theme.colors.neutral100;
    }
    return color ? theme.colors.primary300 : 'inherit';
};

export const LoaderDiv = styled.div`
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: 10;
`;

export const Loader = styled.img`
    width: 150px;
    height: 150px;
    padding: 40px;
    display: flex;
    position: absolute;
    top: calc(50% - 75px);
    right: calc(50% - 150px);
`;

export const CloseButton = styled.div`
    display: flex;
    position: absolute;
    float: right;
    right: 11px;
    font-size: 19px;
    top: 16px;
    color: ${({ theme }) => theme.colors.neutral300};

    :hover {
        color: ${({ theme }) => theme.colors.primary300};
        cursor: pointer;
    }
`;

export const TopDiv = styled.div`
    display: flex;
    justify-content: flex-end;
    height: 40px;
`;

export const ModalDiv = styled.div<any>`
    display: block;
    opacity: ${({ isLoading }) => (isLoading ? '0.4' : '1')};
    margin-top: -18px;
`;

export const ModalTabsDiv = styled.div`
    width: 330px;
    display: flex;
`;

export const PreviewDiv = styled.div`
    margin-top: 60px;
    align-items: center;
    justify-content: center;
    display: flex;
    height: 240px;
`;

export const ImageUploadPreview = styled.img`
    object-fit: contain;
    height: 197px;
    max-width: 100%;
`;

export const DeleteImage = styled(FontAwesomeIcon)`
    font-size: 19px;
    color: ${({ theme }) => theme.colors.primary300};
    cursor: pointer;
    position: absolute;
    right: -14px;
    top: -12px;
`;

export const DropZoneWrapper = styled.div`
    margin: 54px 140px;
`;

export const DropZoneHoverState = styled.div`
    background-color: white;
    height: 22px;
    width: 100px;
    font-size: 16px;
    padding: 4px;
    margin: auto auto;
    font-weight: 600;
`;

export const DropZoneText = styled.p`
    color: ${({ theme }) => theme.colors.neutral700};
    font-size: 15px;
    line-height: 24px;
    margin-bottom: 20px;
    text-align: center;
`;

export const ErrorIcon = styled(FontAwesomeIcon)`
    font-size: 34px;
    color: ${({ theme }) => theme.colors.danger300};
`;

export const ErrorFileName = styled.div`
    color: ${({ theme }) => theme.colors.danger300};
    margin-top: 14px;
    line-height: 24px;
    font-size: 15px;
`;

export const ErrorText = styled.div`
    font-size: 13px;
    line-height: 24px;
    display: flex;
`;

export const BrowseFileLink = styled.label`
    color: ${({ theme }) => theme.colors.primary300};
    text-decoration: underline;
    cursor: pointer;
`;

export const UploadText = styled.p`
    display: flex;
    font-size: 15px;
    line-height: 24px;
`;

export const ModalButtons = styled.div`
    display: flex;
    position: absolute;
    align-self: flex-end;
    margin-left: 415px;
`;

export const ModalGrid = styled.div<any>`
    display: grid;
    grid-template-columns: ${({ displayPreview }) => (displayPreview ? '220px 500px 220px' : '225px 720px')};
    grid-gap: 6px;
    transition: grid-template-columns 3s linear;
`;

export const HelpCenterLink = styled.div`
    color: ${({ theme }) => theme.colors.primary300};
    font-size: 13px;
    line-height: 16px;
    text-align: left;
    margin-top: 8px;
    margin-left: 8px;
    display: inline-flex;
`;

export const Link = styled.a`
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.primary300};
    text-decoration: none;
    &:hover {
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.primary700};
    }
`;
export const FolderColumn = styled.div`
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    height: 417px;
    background-color: white;
`;

export const ImageColumn = styled.div<any>`
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    height: 389px;
    display: grid;
    grid-template-columns: ${({ displayPreview }) => (displayPreview ? '1fr 1fr 1fr 1fr' : '1fr 1fr 1fr 1fr 1fr')};
    grid-template-rows: max-content;
    overflow-y: auto;
    padding: 14px;
    position: relative;
`;

export const ImageDiv = styled.div<any>`
    width: 105px;
    height: 105px;
    margin: 9px auto;
    align-items: center;
    justify-content: center;
    display: flex;
    position: relative;
    background: ${({ theme }) => theme.colors.neutral100};
    border: 2px solid ${({ isSelected, theme }) => (isSelected ? theme.colors.primary300 : 'transparent')};
`;

export const ImageThumbnail = styled.img<any>`
    opacity: ${({ isHovering }) => (isHovering ? '0.3' : '1')};
    display: block;
    width: inherit;
    height: inherit;
    transition: 0.5s ease;
    object-fit: contain;
    position: absolute;
`;

export const ImageActions = styled.div`
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`;

export const CheckBoxBackground = styled.div<any>`
    background-color: ${({ theme }) => theme.colors.neutral000};
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${({ isHovering, isSelected }) => (isSelected ? 1 : isHovering ? 1 : 0)};
    height: 20px;
    width: 20px;
    z-index: 9;
`;

export const CheckBox = styled(FontAwesomeIcon)`
    color: ${({ theme }) => theme.colors.primary300};
    cursor: pointer;
    width: 16px;
    height: 16px;
`;

export const ImagePreviewColumn = styled.div`
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    padding: 15px;
    height: 386px;
`;

export const ImagePreview = styled.img`
    object-fit: contain;
    background-color: ${({ theme }) => theme.colors.neutral100};
    height: 197px;
    width: 192px;
    background-size: cover;
`;

export const ImagePreviewName = styled.div<any>`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 13px;
    line-height: 24px;
    text-align: left;
    display: flex;
    width: 100%;
    cursor: ${({ canManageLibrary }) => (canManageLibrary ? 'pointer' : 'auto')};
    :hover {
        background-color: ${({ theme }) => theme.colors.pastelPrimary300};
        color: ${({ theme }) => theme.colors.primary700};
    }
`;

export const ImagePreviewInfo = styled.div`
    color: ${({ theme }) => theme.colors.neutral700};
    font-size: 13px;
    line-height: 24px;
    text-align: left;
`;

export const UploadToPikassoButton = styled.div`
    width: 100%;
    margin-top: 51px;
`;

export const IconsDiv = styled.span<any>`
    color: ${({ theme, color, disable }) => returnColor(disable, color, theme)};
    cursor: ${({ disable }) => (disable ? 'not-allowed' : 'pointer')};
    pointer-events: ${({ disable }) => (disable ? 'none' : 'auto')};
`;

export const Icon = styled(FontAwesomeIcon)`
    width: 16px;
    height: 16px;
    margin-right: 8px;
    cursor: pointer;
`;

export const FolderDiv = styled.div<any>`
    padding: 12px;
    display: flex;
    cursor: pointer;
    color: ${({ selected, theme }) => (selected ? theme.colors.primary300 : theme.colors.neutral700)};
    background-color: ${({ selected, theme }) => (selected ? theme.colors.pastelPrimary300 : theme.colors.white)};
    border-left: ${({ selected, theme }) => (selected ? `3px solid ${theme.colors.primary300}` : 'none')};
`;

export const FolderList = styled.div<any>`
    display: block;
    height: ${({ canManageLibrary }) => (canManageLibrary ? '375px' : '100%')};
    overflow: auto;
`;

export const FolderName = styled.div<any>`
    color: ${({ selected, theme }) => (selected ? theme.colors.primary300 : theme.colors.neutral900)};
    font-weight: ${({ selected }) => (selected ? 600 : 200)};
    width: 100%;
    display: flex;
    font-size: 14px;
    text-align: left;
    line-height: 24px;
    margin-left: 11px;
`;

export const FolderNameDiv = styled.div`
    width: 95%;
`;

export const FolderIconsDiv = styled.div`
    width: 57px;
`;

export const IconDiv = styled.div`
    color: ${({ theme }) => theme.colors.primary300};
    display: flex;
    place-items: center;
    margin-left: 6px;
`;

export const FolderNameInput = styled.input`
    color: ${({ theme }) => theme.colors.primary300};
    font-size: 15px;
    line-height: 24px;
    text-align: left;
    width: 108px;
    height: 24px;
    background-color: ${({ theme }) => theme.colors.white};
    border: ${({ theme }) => `1px solid ${theme.colors.primary300}`};
    margin-right: 5px;
    :focus {
        outline: none;
        border: ${({ theme }) => `1px solid ${theme.colors.primary300}`};
    }
`;

export const NewFolderDiv = styled.div`
    display: flex;
    position: absolute;
    bottom: 70px;
    margin-left: 15px;
    align-self: flex-end;
`;

export const FolderIcon = styled(FontAwesomeIcon)`
    font-size: ${({ icon }) => (icon === 'plus-circle' ? '20px' : '24px')};
    color: ${({ theme, icon }) => (icon === 'plus-circle' ? theme.colors.success300 : 'inherit')};
`;

export const CreateFolderText = styled.div`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 12px;
    text-align: left;
    line-height: 19px;
    margin-left: 11px;
    cursor: pointer;
`;

export const EmptyStateDiv = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    height: 416px;
    text-align: center;
`;

export const EmptyStateImg = styled.img`
    margin-top: 47px;
`;

export const ArrowImg = styled.img`
    margin-left: 67px;
    position: absolute;
    margin-top: 43px;
`;

export const EmptyFolderMsg = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 15px;
    text-align: center;
    line-height: 32px;
    font-weight: 600;
`;

export const ActionHelperMsg = styled.p`
    color: ${({ theme }) => theme.colors.neutral700};
    font-size: 15px;
    line-height: 24px;
`;

export const ModalHeader = styled.h3`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 20px;
    font-weight: 600;
    height: 25px;
    width: 163px;
`;

export const DeleteModalButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
`;

export const DeleteWarning = styled.div`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 15px;
    line-height: 24px;
    width: 304px;
    text-align: left;
    font-weight: 600;
    margin-top: 24px;
`;

export const ModalText = styled.div`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 15px;
    line-height: 24px;
    width: 304px;
    text-align: left;
`;

export const DropDown = styled.div`
    overflow: auto;
    background: rgb(255, 255, 255);
    border-radius: 0px;
    border: 1px solid rgb(204, 204, 204);
    box-shadow: 0px 0px 4px 0px rgba(28, 28, 28, 0.2);
    width: 197px;
    height: 140px;
    position: absolute;
    text-align: left;
    right: 39px;
    top: 122px;
    font-size: 16px;
    cursor: pointer;
    z-index: 10;
`;

export const DropDownItem = styled.div`
    color: rgb(28, 28, 28);
    font-size: 13px;
    font-weight: normal;
    height: 20px;
    letter-spacing: 0px;
    line-height: 20px;
    display: flex;
    text-align: left;
    padding: 9px 7px 7px 8px;
`;
export const RenamingContentIcons = styled.div`
    display: flex;
    font-size: 12;
    line-height: 1;
`;

export const FileNameInput = styled.input`
    color: ${({ theme }) => theme.colors.primary300};
    font-size: 13px;
    text-align: left;
    width: 70%;
    height: 19px;
    line-height: 30px;
    background-color: ${({ theme }) => theme.colors.white};
    border: ${({ theme }) => `1px solid ${theme.colors.primary300}`};
    margin-right: 5px;
    :focus {
        outline: none;
        border: ${({ theme }) => `1px solid ${theme.colors.primary300}`};
    }
`;

export const RenameContentDiv = styled.div`
    width: 20%;
    text-align: right;
    margin-top: 3px;
`;

export const FileNameDiv = styled.div`
    width: 85%;
`;

export const CloseButtonWrapper = styled.div`
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
`;

export const CloseIcon = styled(FontAwesomeIcon)`
    font-size: 18px;
    margin: 2px 12px 6px 12px;
`;

interface UploadingImageBackgroundProps {
    shouldRender: boolean;
}
export const UploadingImageBackground = styled.div<UploadingImageBackgroundProps>(({ shouldRender }) => ({
    position: 'absolute',
    top: 123,
    left: 271,
    right: 47,
    bottom: 59,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: shouldRender ? 'flex' : 'none',
    alignItems: 'center',
    justifyContent: 'center',
}));
